// extracted by mini-css-extract-plugin
module.exports = {"partner_badge":"_6c97079b1b--partner_badge--u5TAw"};